import { useEffect } from 'react';

import * as userStore from '@cartwhl/common/stores/userStore';

const FORM_TAG_NAMES = new Set(['INPUT', 'SELECT', 'TEXTAREA']);

/** Toggles the color theme with Shift + L. */
export default function useThemeHotkey({
  persist = true,
}: { persist?: boolean } = {}) {
  useEffect(() => {
    userStore.setTheme(userStore.state.theme, { persist });

    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target;
      const isEditableTarget =
        target instanceof HTMLElement &&
        (target.isContentEditable || FORM_TAG_NAMES.has(target.tagName));

      if (
        event.repeat ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        !event.shiftKey ||
        event.key.toLowerCase() !== 'l' ||
        isEditableTarget
      ) {
        return;
      }

      event.preventDefault();
      userStore.setTheme(userStore.state.theme === 'dark' ? 'light' : 'dark', {
        persist,
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [persist]);
}
